export default __webpack_public_path__ + "static/media/backIcon.5c2f085d.svg";